import { IssueLayout, IssueLayoutArticle, IssueLayoutArticleBlock, IssueLayoutLink, IssueLayoutPage } from '@pressreader/content-types';
import { IRect } from '@pressreader/geometry';
import { newGuid } from '@pressreader/utils';

import { IIssueLayoutArticleDto, IIssueLayoutDto, IIssueLayoutLinkDto, IIssueLayoutPageDto } from '../types';

function mapIssueLayoutArticleDto(dto: IIssueLayoutArticleDto): IssueLayoutArticle {
    return {
        uniqId: newGuid(),
        regionId: dto.RegionId,
        rootRegionId: dto.RootRegionId,
        articleId: dto.Id,
        rootArticleId: dto.RootArticleId,
        rect: { top: dto.Y, left: dto.X, width: dto.W, height: dto.H },
        blocks:
            dto.Blocks?.map<IssueLayoutArticleBlock>(b => ({
                uniqId: newGuid(),
                blockType: b.BT,
                linkDirection: b.LD,
                rect: { top: b.Y, left: b.X, width: b.W, height: b.H },
                articleId: b.PID,
                regionId: dto.RegionId,
            })) ?? [],
    };
}

function mapIssueLayoutLinkDto(dto: IIssueLayoutLinkDto): IssueLayoutLink {
    return {
        uniqId: newGuid(),
        type: dto.Type as number,
        target: dto.Target,
        rects: dto.Rects?.map<IRect>(r => ({ top: r.Y, left: r.X, width: r.W, height: r.H })) ?? [],
    };
}

function mapIssueLayoutPage(dto: IIssueLayoutPageDto): IssueLayoutPage {
    return {
        pageNumber: dto.PageNumber,
        articles: dto.Articles?.map(mapIssueLayoutArticleDto) ?? [],
        links: dto.Links?.map(mapIssueLayoutLinkDto) ?? [],
    };
}

function mapIssueLayoutDto(dto: IIssueLayoutDto): IssueLayout {
    return {
        pages: dto.Pages?.map(mapIssueLayoutPage) ?? [],
    };
}

export { mapIssueLayoutDto };
